import request from "./request";

let baseUrl
if (process.env.NODE_ENV === "development") {
    baseUrl = "http://172.20.10.2:5000";
}else {
    baseUrl = 'http://42.193.218.104:6355'
}
export function getBannerList() {
    return request({
        url: baseUrl+`/getBannerList`,
        method: "GET",
    });
}
export function getPlayList(data) {
    return request({
        url: baseUrl+`/getRcmPlayList`,
        params:data,
        method: "GET",
    });
}
export function getTagPlayList(data) {
    return request({
        url: baseUrl+`/getTagPlayList`,
        params:data,
        method: "GET",
    });
}

export function getMvList(data) {
    return request({
        url: baseUrl+`/getMvList`,
        params:data,
        method: "GET",
    });
}
export function getPlayListInfo(data) {
    return request({
        url: baseUrl+`/playListInfo`,
        params:data,
        method: "GET",
    });
}
export function getComment(data) {
    return request({
        url: baseUrl+`/getComment`,
        params:data,
        method: "GET",
    });
}

export function getSongInfo(data) {
    return request({
        url: baseUrl+`/songinfoandlrc`,
        params:data,
        method: "GET",
    });
}
export function getSongUrl(id) {
    return request({
        url: baseUrl+`/getSongUrl?rid=${id}`,
        method: "GET",
    });
}

export function getMusicInfo(id) {
    return request({
        url: baseUrl+`/musicInfo?mid=${id}`,
        method: "GET",
    });
}

// 93酷我飙升榜
//17酷我新歌榜
//16酷我热歌榜
//158酷我抖音榜
//176酷我dj榜
//145会员畅听榜
export function getTopListInfo(data) {
    return request({
        url: baseUrl+`/topListInfo`,
        method: "GET",
        params:data,
    });
}
// 11 华语
// 13 欧美
// 12 日韩
// 16 组合
export function getArtistInfo(data) {
    return request({
        url: baseUrl+`/artistInfo`,
        method: "GET",
        params:data,
    });
}

export function getArtistMusic(data) {
    return request({
        url: baseUrl+`/artistMusic`,
        method: "GET",
        params:data,
    });
}
export function getAlbumInfo(albumId) {
    return request({
        url: baseUrl+`/albumInfo?albumId=${albumId}`,
        method: "GET",
    });
}
export function getSingerInfo(artistid) {
    return request({
        url: baseUrl+`/singerInfo?artistid=${artistid}`,
        method: "GET",
    });
}
export function getMoreArtist(data) {
    return request({
        url: baseUrl+`/moreArtist`,
        method: "GET",
        params:data,
    });
}
export function getMoreAlbum(data) {
    return request({
        url: baseUrl+`/artistAlbum`,
        method: "GET",
        params:data,
    });
}
export function getArtistMv(data) {
    return request({
        url: baseUrl+`/artistMv`,
        method: "GET",
        params:data,
    });
}
export function getSearchData(data) {
    return request({
        url: baseUrl+`/getSearchData`,
        method: "GET",
        params:data,
    });
}

export function getSearchAlbum(data) {
    return request({
        url: baseUrl+`/searchAlbum`,
        method: "GET",
        params:data,
    });
}

export function getSearchMv(data) {
    return request({
        url: baseUrl+`/searchMv`,
        method: "GET",
        params:data,
    });
}

export function getSearchPlayList(data) {
    return request({
        url: baseUrl+`/searchPlayList`,
        method: "GET",
        params:data,
    });
}

export function getSearchArtist(data) {
    return request({
        url: baseUrl+`/searchArtist`,
        method: "GET",
        params:data,
    });
}

export function getSearchKey(key) {
    return request({
        url: baseUrl+`/searchKey`,
        method: "GET",
        params:{key:key},
    });
}
export function getMvUrl(mid) {
    return request({
        url: baseUrl+`/getMvUrl`,
        method: "GET",
        params:{mid:mid},
    });
}

